import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
// Kendo controls
import { Button } from '@progress/kendo-react-buttons';
import { DropDownList } from "@progress/kendo-react-dropdowns";

import { AllActionId } from '../../../Models/StateModel/ActionStateModel';
import { CompanySelected } from '../../../Constants/ConstantsValue';
import { storageModel } from '../../../Models/CommonModel/StorageModel';

import Screen from "../../../Resources/Screen.json";


export default function CmbFiscalPeriod(props) {
    const fiscalPeriodModel = useSelector(state => state.MainPage.fiscalPeriodModel);
    const actionState = useSelector(state => state.ActionState.actionState);

    let companySelected = storageModel.GetItem(CompanySelected);

    // FiscalPeriods Combobox
    const [selectedFiscalPeriod, setSelectedFiscalPeriod] = useState(null);
    const [fiscalPeriodData, setFiscalPeriodData] = useState(null);

    // AccountingStandardType Combobox
    const [accTypeData, setAccTypesData] = useState(null);
    const [selectedAccTypeData, setSelectedAccTypeData] = useState(null);

    useEffect(() => {
        document.getElementsByClassName("k-input").forEach(element => {
            element.disabled = true;
        });
        if (!fiscalPeriodModel || fiscalPeriodModel.FiscalPeriods.length <= 0)
            return;

        // Bindding fiscalPeriods
        let fiscalPeriods = fiscalPeriodModel.GetDisplayFiscalPeriods();
        setFiscalPeriodData(fiscalPeriods);
        setSelectedFiscalPeriod(fiscalPeriods[0]);

        // Bindding AccountingStandardType
        let accTypes = fiscalPeriodModel.GetTargetAccountingStandardTypes(0);
        setAccTypesData(accTypes);
        setSelectedAccTypeData(accTypes[0]);

        // Set change selection 
        props.selectionChange(fiscalPeriods[0], accTypes[0]);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fiscalPeriodModel]);

    const onChangeFiscalPeriodModel = (event) => {
        if (fiscalPeriodModel) {
            setSelectedFiscalPeriod(event.value);

            let accTypes = fiscalPeriodModel.GetTargetAccountingStandardTypes(event.value.Index);
            setAccTypesData(accTypes);
            setSelectedAccTypeData(accTypes[0]);

            // Call parent action
            props.selectionChange(event.value, accTypes[0]);
        }
    }

    const selectCompany = () => {
        props.selectCompany();
    }

    const onClickReload = () => {
        props.reloadFiscalPeriod();
    }

    const onChangeAccType = (event) => {
        setSelectedAccTypeData(event.value);

        // Call parent action
        props.selectionChange(selectedFiscalPeriod, event.value);
    }

    return <React.Fragment>
        {actionState && <div className="pnxBlockForm">
            <div className="pnxBlockContent">
                <div className="row justify-content-center cmbfiscalPeriodModel">
                    <div style={{ width: "100px", minWidth: "100px", alignSelf: "center" }}>{Screen.CmbFiscalPeriod.LableFiscalPeriod}</div>
                    <DropDownList className="pnxCombobox" style={{ maxWidth: "500px", margin: "0px" }}
                        disabled={actionState.IsDisable(AllActionId.CmbFiscalPeriodModel)}
                        data={fiscalPeriodData ?? []}
                        dataItemKey="Index"
                        textField="DisplayText"
                        value={selectedFiscalPeriod ?? {}}
                        onChange={onChangeFiscalPeriodModel}
                    />
                    <div style={{ width: "100px", minWidth: "100px", alignSelf: "center", marginLeft: "40px" }}>{Screen.CmbFiscalPeriod.LableAccountingStandardType}</div>
                    <DropDownList className="pnxCombobox" style={{ maxWidth: "500px", marginLeft: "20px" }}
                        disabled={actionState.IsDisable(AllActionId.CmbAccType)}
                        data={accTypeData ?? []}
                        dataItemKey="DisplayText"
                        textField="DisplayText"
                        clearButton={false}
                        defaultValue={selectedAccTypeData}
                        onChange={onChangeAccType}
                        value={selectedAccTypeData}
                    />
                    <Button
                        disabled={actionState.IsDisable(AllActionId.BtnReloadFiscalPeriod)}
                        style={{ marginLeft: "10px", width: "192px" }}
                        className="btn pnxBtnPrimary searchAccount"
                        onClick={onClickReload}
                    > {Screen.CmbFiscalPeriod.ButtonReload}
                    </Button>
                </div>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "end", flexWrap: "wrap", marginTop: "-5px" }}>
                    <span style={{ marginRight: "0px" }}>{companySelected && companySelected.DisplayName}</span>
                    <Button
                        disabled={actionState.IsDisable(AllActionId.BtnSelectCompany)}
                        style={{ width: "168px" }}
                        className="btn pnxBtnPrimary searchAccount"
                        onClick={selectCompany}>
                        {Screen.CmbFiscalPeriod.ButtonSelectCompany}
                    </Button>
                </div>
            </div>
        </div>
        }
    </React.Fragment>
}
